import { createSelector } from "@reduxjs/toolkit";
import { IShuffleAttendeesState } from "../types";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const selectShuffleAttendees = (state: any) => state.shuffleAttendees;
const makeSelectShowShuffleDialog = () =>
  createSelector(
    selectShuffleAttendees,
    (substate: IShuffleAttendeesState) =>
      substate.isShuffleAttendeesDialogVisible,
  );
const makeSelectShowShuffleCountdownDialog = () =>
  createSelector(
    selectShuffleAttendees,
    (substate: IShuffleAttendeesState) =>
      substate.isShuffleAttendeesCountdownDialogVisible,
  );
const makeSelectShowShuffleCountdownBanner = () =>
  createSelector(
    selectShuffleAttendees,
    (substate: IShuffleAttendeesState) =>
      substate.isShuffleAttendeesCountdownBannerVisible,
  );
const makeSelectShowInitShuffleBanner = () =>
  createSelector(
    selectShuffleAttendees,
    (substate: IShuffleAttendeesState) => substate.isInitShuffleBannerVisible,
  );
const makeSelectShuffleStartTime = () =>
  createSelector(
    selectShuffleAttendees,
    (substate: IShuffleAttendeesState) => substate.shuffleStartTime,
  );

export {
  makeSelectShowShuffleDialog,
  makeSelectShowShuffleCountdownDialog,
  makeSelectShowShuffleCountdownBanner,
  makeSelectShowInitShuffleBanner,
  makeSelectShuffleStartTime,
};
